import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-found-error',
  templateUrl: './not-found-error.component.html',
  styleUrls: ['./not-found-error.component.sass']
})
export class NotFoundErrorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
